/* Pond Haven collection redesign: scroll-reveal for product cards.
   Vanilla, progressive enhancement, no globals overridden, no MutationObserver.

   Products must NEVER be blank. Cards are VISIBLE BY DEFAULT (see ph-collection.css):
   this IIFE only HIDES the below-fold cards present at first load, animates each one in as
   it scrolls into view, and keeps a backstop so none can stay hidden. Crucially, Booster
   paginates with AJAX: renderChangePage() swaps the product grid in place via history
   pushState, with no full page load and no shopify:section:load event. Those AJAX-injected
   cards (next/prev pages AND a Back-button return to a previous page) are never touched by
   this script, so they render visible immediately. The previous version hid ALL cards via an
   <html>.ph-reveal ancestor class and only observed the cards present at first load, so every
   AJAX-swapped card was hidden with nothing to reveal it = the blank-grid bug on page 2+. */
(function () {
  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product__list .card--holder'));
    if (!cards.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) show(entries[i].target);
      }
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

    function show(el) { el.classList.add('ph-in'); io.unobserve(el); }
    function viewportH() { return window.innerHeight || document.documentElement.clientHeight; }

    /* Hide + animate ONLY the below-fold cards from the first server-rendered page. Every
       card we hide is observed and covered by the backstop, so nothing we hide can stay
       hidden. In/above-fold cards are left visible (instant, no flash). */
    var armed = [];
    var h = viewportH();
    cards.forEach(function (el) {
      if (el.getBoundingClientRect().top >= h) {
        el.classList.add('ph-fade');
        io.observe(el);
        armed.push(el);
      }
    });

    /* If the page loads already scrolled (scroll restoration, or a full-reload back/forward),
       reveal any armed card that is actually in view rather than waiting for a scroll event. */
    function revealInView() {
      var vh = viewportH();
      for (var i = armed.length - 1; i >= 0; i--) {
        if (!armed[i].classList.contains('ph-in') && armed[i].getBoundingClientRect().top < vh) show(armed[i]);
      }
    }
    window.addEventListener('load', revealInView);

    /* Absolute backstop: never leave an armed card hidden. */
    setTimeout(function () {
      for (var i = 0; i < armed.length; i++) show(armed[i]);
    }, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Pond School: custom premium scroll progress bar on mobile. The native scrollbar
   is hidden in CSS; this gives an intentional, on-brand affordance that the tiles
   scroll. Builds a track + thumb, sets thumb width to the visible ratio, and moves
   it with scrollLeft (rAF-throttled, passive). Hidden on desktop (no overflow). */
(function () {
  function build(scroller) {
    if (scroller.dataset.phBar === '1') return;
    scroller.dataset.phBar = '1';

    var inner = scroller.closest('.ph-school-tiles__inner') || scroller.parentNode;
    var bar = document.createElement('div');
    bar.className = 'ph-school-tiles__bar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'ph-school-tiles__bar-thumb';
    bar.appendChild(thumb);
    inner.appendChild(bar);

    function maxScroll() { return scroller.scrollWidth - scroller.clientWidth; }

    function update() {
      var max = maxScroll();
      var p = max > 0 ? scroller.scrollLeft / max : 0;
      var travel = bar.clientWidth - thumb.offsetWidth;
      thumb.style.transform = 'translate3d(' + (p * travel) + 'px,0,0)';
    }

    function sync() {
      if (maxScroll() <= 4) { bar.style.display = 'none'; return; }
      bar.style.display = 'block'; // show whenever the row actually overflows (any width)
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      thumb.style.width = Math.max(ratio * 100, 16) + '%';
      update();
    }

    var raf = 0;
    scroller.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });

    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(sync, 180); });

    /* Make the bar an interactive scrollbar: drag the thumb or tap the track to
       scroll the carousel. Positions the thumb centre under the pointer. */
    var dragging = false;
    function pointerToScroll(clientX) {
      var travel = bar.clientWidth - thumb.offsetWidth;
      if (travel <= 0) return;
      var x = clientX - bar.getBoundingClientRect().left - thumb.offsetWidth / 2;
      if (x < 0) x = 0;
      if (x > travel) x = travel;
      scroller.scrollLeft = (x / travel) * maxScroll();
    }
    bar.addEventListener('pointerdown', function (e) {
      if (maxScroll() <= 4) return;
      dragging = true;
      try { bar.setPointerCapture(e.pointerId); } catch (_) {}
      scroller.style.scrollBehavior = 'auto';     // no smooth lag while dragging
      scroller.style.scrollSnapType = 'none';     // snap must not fight the drag
      pointerToScroll(e.clientX);
      e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) {
      if (dragging) pointerToScroll(e.clientX);
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { bar.releasePointerCapture(e.pointerId); } catch (_) {}
      scroller.style.scrollBehavior = '';
      scroller.style.scrollSnapType = '';
    }
    bar.addEventListener('pointerup', endDrag);
    bar.addEventListener('pointercancel', endDrag);

    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(sync); }
    sync();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.ph-school-tiles__grid'), build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: rebuild when the section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();

/* Pond Haven collection view toggle: grid (default 3-up cards) vs list (1 per
   row, image left + details right). Pure CSS class on .product__list, no second
   template, no Booster JS dependency. Choice persists in sessionStorage. */
(function () {
  var KEY = 'ph-coll-view';
  function grids() { return document.querySelectorAll('.product__list'); }
  function apply(view) {
    grids().forEach(function (g) { g.classList.toggle('ph-view--list', view === 'list'); });
    var btns = document.querySelectorAll('[data-ph-view-toggle] [data-ph-view]');
    Array.prototype.forEach.call(btns, function (b) {
      var on = b.getAttribute('data-ph-view') === view;
      b.classList.toggle('view--active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function init() {
    var toggle = document.querySelector('[data-ph-view-toggle]');
    if (!toggle || toggle.dataset.phBound === '1') return;
    toggle.dataset.phBound = '1';
    var saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (e) {}
    if (saved === 'list') apply('list');
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ph-view]');
      if (!btn) return;
      var view = btn.getAttribute('data-ph-view');
      apply(view);
      try { sessionStorage.setItem(KEY, view); } catch (e2) {}
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
